module.exports = __webpack_public_path__ + "img/79ne.a4667a26.svg";